export const JACKPOT_MODULE_NAMES = {
  LOCAL: 'lokalni',
  GLOBAL: 'globalni'
};

export const VOUCHER_MODULE_NAMES = {
  SHOP_VOUCHERS: 'prodavnica',
  MY_VOUCHERS: 'moji-vauceri'
};

export const BETTING_TASKS_MODULES = {
  IN_PROGRESS: 'In progress',
  FINISHED: 'Finished'
};

export const CONNECTION_EVENTS = {
  CONNECTED: 'Connected',
  DISCONNECTED: 'Disconnected',
  DISCONNECT: 'Disconnect',
  RECIEVE_MESSAGE: 'ReceiveMessage'
};

export const NOTIFICATION_CATEGORY = {
  ALL: 'Sve',
  MBC: 'MBC',
  SPORT: 'Sport',
  SLOT: 'Slot'
};

export const VOUCHER_FILTER_NAME = {
  ALL: 'Svi',
  SPORT: 'Sport',
  SLOT: 'Casino',
  PRODUCT: 'Robni',
  MBC: 'MBC'
};

export const VOUCHER_CATEGORY = {
  ALL: 'Svi',
  SPORT: 'Klađenje',
  SLOT: 'Slot',
  PRODUCT: 'Robna nagrada',
  MBC: 'MBC nagrada'
};

export const HISTORY_MODULES = {
  MAX_CAFE: 'max-cafe',
  BETTING: 'betting',
  MBC_EXPIRED: 'mbc-expired'
};
